import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { commitMarker } from '../../redux/actions';

const useStyles = createUseStyles({
  container: {
    border: '1px solid rgba(0, 0, 0, 0.15)',
    borderRadius: 4,
    composes: ['py12', 'px12'],
    marginTop: 12,
  },
  input: {
    width: '100%',
  },
});

const NameInputComponent = React.memo(({ data }) => {
  const classes = useStyles();
  const [value, setValue] = useState(data?.name || '');
  const dispatch = useDispatch();

  const inputChangeHandler = useCallback(
    ({ target }) => setValue(target.value),
    []
  );

  const inputBlurHandler = useCallback(
    ({ target }) => {
      const name = target.value.trim();
      const next = { ...data, name };
      dispatch(commitMarker(next));
    },
    [data, dispatch]
  );

  return (
    <div className={classes.container}>
      <input
        className={classes.input}
        placeholder="Nom du marker"
        type="text"
        value={value}
        onBlur={inputBlurHandler}
        onChange={inputChangeHandler}
      />
    </div>
  );
});

NameInputComponent.propTypes = {
  data: PropTypes.shape({
    category: PropTypes.string,
    name: PropTypes.string,
    region: PropTypes.string,
  }).isRequired,
};

NameInputComponent.displayName = 'NameInputComponent';

export default NameInputComponent;
